
import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import axios from 'axios';
import { apiUrl, mediaUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import {CKEditor}  from 'ckeditor4-react';

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();

		// Suppress CKEditor 4.22.1 security warning
		if (window.CKEDITOR) {
			window.CKEDITOR.disableAutoInline = true;
		}

		this.state = {
			m_title:'',
			description:'',
			planInfo:'',
			amount:'',
			earned_bonus_pts:'',
			discount:'',
			towDiscount:'',
			driverCount:'1',
			companyCount:'1',
			period:'',
			Loading:false,
			selectedOption:{ value: 'active', label: 'Active'},
			selectedPeriodOption: "",
			selectedPlanOption: "",
			selectedvalue:'active',
			selectedPeriodvalue:'',
			selectedPlanvalue:'',
			icon_preview : '',
			selectedUserType : '',

		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onEditorChange = this.onEditorChange.bind( this );
    }
	  
	onEditorChange(fieldName, evt) {
		var callfunc = this;
		setTimeout(function () {
			if(fieldName === 'description'){
				const data = evt.editor.getData();
				const converted = callfunc.emojiToEntity(data);
				callfunc.setState({
					description: converted
				});
			}
			else if(fieldName === 'planInfo'){
				const data = evt.editor.getData();
				const converted = callfunc.emojiToEntity(data);
				callfunc.setState({
					planInfo: converted
				});
			}
		}, 1000);
	}

	emojiToEntity(str) {
		return str.replace(/\p{Emoji_Presentation}|\p{Emoji}️/gu, emoji => {
			return `&#${emoji.codePointAt(0)};`;
		});
	}

	entityToEmoji(str) {
		// Decode HTML entities back to characters/emojis
		const textarea = document.createElement('textarea');
		textarea.innerHTML = str;
		return textarea.value;
	}
	
	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'period'){
			this.setState({selectedPeriodOption:selOption})
			this.setState({  selectedPeriodvalue : selOption.value});
		}else if(r == 'plan'){			
			this.setState({selectedPlanOption:selOption})
			this.setState({  selectedPlanvalue : selOption.value});
			this.setState({  selectedUserType : selOption.type});
		}
		console.log(selOption, 'selopt')
		console.log(r, 'r')
   };

   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
		console.log(name + ' ~ ' + value, 'name')

  }
  	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
			this.setState({
				icon_name: file.name,
				icon_preview: reader.result,
				icon: file,
				icon_fileExtension:extension,			
			});
		};
		reader.readAsDataURL(file);
	} 

  handleSubmit = () => {
	if(this.validateForm()){ 
		this.setState({Loading:true});
		const formdata = this.state;
		var qs = require('qs');
		var status = '';
		var period = '';
		var plan = '';
		if(formdata.selectedvalue === ''){
		status =formdata.selectedOption.value;
		}else{
		status = formdata.selectedvalue;
		}

		if(formdata.selectedPeriodvalue === '' && formdata.selectedPeriodvalue!== 0){
			period =formdata.selectedPeriodOption.value;
		}else{
			period = formdata.selectedPeriodvalue;
		}

		if(formdata.selectedPlanvalue === '' && formdata.selectedPlanvalue!== 0){
			plan =formdata.selectedPlanOption.value;
		}else{
			plan = formdata.selectedPlanvalue;
		}

		var postObject ={
			admin_id : localStorage.getItem("admin_id"),
			title: formdata.m_title,
			description: formdata.description,
			planInfo: formdata.planInfo,
			amount: formdata.amount,
			earned_bonus_pts:formdata.earned_bonus_pts,
			discount: formdata.discount,
			towDiscount: formdata.towDiscount,
			driverCount: formdata.driverCount,
			companyCount: formdata.companyCount,
			period: period,
			plan: plan,
			status:  status,
		}
		

		let formData = new FormData();
		for(let k in postObject) {
			formData.append(k, postObject[k]);
		}
		var icondata = formdata.icon;
		formData.append('file',icondata)
		//axios.post(apiUrl+"membership/add",qs.stringify(postObject)).then(res => {
		axios.post(apiUrl+"membership/add",formData).then(res => {
			if(res.data.status === "success"){
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
							setTimeout(
							function() {
								$('.success_message').html(this.props.navigate('/membership'));
							}
							.bind(this),
							3000
							);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
		});

	}
		
	}

	validateForm() {
		//const {admin_company_name,admin_fname} = this.state;
		const {m_title,description, planInfo,amount,period,selectedPeriodOption,selectedPlanOption, discount, towDiscount, driverCount, companyCount, selectedUserType, earned_bonus_pts} = this.state;
		let errors = {};
      	let formIsValid = true;
		  const nameRegex = /^[A-Za-z\s.]+$/;
		
		if (!m_title) {
			errors++;
			$('.errortitle').html('<span class="errorspan">Please fill the field</span>');
		}else if(m_title){
			if (!nameRegex.test(m_title)) {
				errors++;
			$('.errortitle').html('<span class="errorspan">Please enter the valid membership</span>');
			}else{
				$('.errortitle').html('');
			}
			
		}
		if (!description) {
			formIsValid = false;
			$('.errordescription').html('<span class="errorspan">Please fill the field</span>');
		}else if(description){
			$('.errordescription').html('');
		}
		
		if (!amount) {
			formIsValid = false;
			$('.erroramount').html('<span class="errorspan">Please fill the field</span>');
		}else if(amount){
			if (/^[0-9]*\.?[0-9]*$/.test(amount)) {
				$('.erroramount').html('');
			  }else{
				formIsValid = false;
			$('.erroramount').html('<span class="errorspan">Please enter the valid amount</span>');
			  }

			
		}

		 if(earned_bonus_pts){
			if (/^[0-9]*\.?[0-9]*$/.test(earned_bonus_pts)) {
				$('.errorearned_bonus_pts').html('');
				}else{
				formIsValid = false;
				$('.errorearned_bonus_pts').html('<span class="errorspan">Please enter the valid earned points</span>');
			}
		}

		

		if (!selectedPeriodOption) {
			formIsValid = false;
			$('.errorperiod').html('<span class="errorspan">Please fill the field</span>');
		}else if(selectedPeriodOption){
			$('.errorperiod').html('');
		}

		if (!selectedPlanOption) {
			formIsValid = false;
			$('.errorplan').html('<span class="errorspan">Please fill the field</span>');
		}else if(selectedPlanOption){
			$('.errorplan').html('');
		}

		if(selectedUserType == 'rider' || selectedUserType == 'company'){
			if (!discount) {
				formIsValid = false;
				$('.errordiscount').html('<span class="errorspan">Please fill the field</span>');
			}else if(discount){
				// validate discount number 100 percent
				if (/^(100|[1-9]?[0-9])$/.test(discount)) {
					$('.errordiscount').html('');
			  	}else{	
					formIsValid = false;
					$('.errordiscount').html('<span class="errorspan">Please enter the valid discount (0-100)</span>');
			  	}
			}
		}
		if(selectedUserType == 'rider' || selectedUserType == 'driver'){
			if (!towDiscount) {
				formIsValid = false;
				$('.errortowDiscount').html('<span class="errorspan">Please fill the field</span>');
			}else if(towDiscount){
				// validate towDiscount number 100 percent
				if (/^(100|[1-9]?[0-9])$/.test(towDiscount)) {
					$('.errortowDiscount').html('');
			  	}else{	
					formIsValid = false;
					$('.errortowDiscount').html('<span class="errorspan">Please enter the valid tow booking discount (0-100)</span>');
			  	}
			}
		}
		if(selectedUserType == 'company'){
			if (!driverCount) {
				formIsValid = false;
				$('.errordriverCount').html('<span class="errorspan">Please fill the field</span>');
			}else if(driverCount){
				if (/^[0-9]+$/.test(driverCount)) {
					$('.errordriverCount').html('');
				}else{
					formIsValid = false;
					$('.errordriverCount').html('<span class="errorspan">Please enter the valid driver count</span>');
				}
			}
		}
		if(selectedUserType == 'driver'){
			if (!companyCount) {
				formIsValid = false;
				$('.errorcompanyCount').html('<span class="errorspan">Please fill the field</span>');
			}else if(companyCount){
				if (/^[0-9]+$/.test(companyCount)) {
					$('.errorcompanyCount').html('');
				}else{
					formIsValid = false;
					$('.errorcompanyCount').html('<span class="errorspan">Please enter the valid company count</span>');
				}
			}
		}

		this.setState({
			errors: errors
		});
		return formIsValid;
    }



render() {

	var	preview = (this.state.icon_preview) ? 
	<img className="img_class" src={this.state.icon_preview} alt="" /> :'';
	const {selectedOption,selectedPeriodOption,selectedPlanOption} = this.state;
	var current = this;	

    return (
      	<div className="wrapper"> 
 
			<Header />
			<MenuSidebar currentpage="membership" currentTab="common" currentSubTab="membership-management"/>  

			<div id="location-error"></div>
			<div className="content">	
				<div className="content-wrapper">
					<div class="content-wrapper-before"></div>
					<div className="form-wrapper leaa-admin-head card">
						<div className="success_message"></div>
						<div>
							<a class="primary-btn" href="/membership">Back</a>
						</div>
						<div className="title">
							<h4>Add Membership</h4>				
						</div>
						<form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
							<div className="form-row">
								<div className="form-left">
									<div className="form-group">					
										<label>Membership Category<span class="required" style={{ color: "red" }} >* </span></label>
										<Select 
											value={selectedPlanOption?selectedPlanOption:""}
											options={lang.common.mem_plan_option} 
											onChange={this.handleChange.bind(this, 'plan')}
										/>
										<div className="errorplan"></div>
									</div> 
									<div className="form-group">
										<label> Amount ($)<span class="required" style={{ color: "red" }} >* </span> </label>
										<input type="text"  name="amount" onChange={this.handleInputChange} className="form-control" value={this.state.amount} />
										<div className="erroramount"></div>
									</div>
									<div className="form-group">
										<label> Earning bonus points  </label>
										<input type="text"  name="earned_bonus_pts" onChange={this.handleInputChange} className="form-control" value={this.state.earned_bonus_pts} />
										<div className="errorearned_bonus_pts"></div>
									</div>
									{(this.state.selectedUserType == 'rider' || this.state.selectedUserType == 'company') &&
									<>
									<div className="form-group">
										<label> Discount (%)<span class="required" style={{ color: "red" }} >* </span></label>
										<input type="text"  name="discount" onChange={this.handleInputChange} className="form-control" value={this.state.discount} />			
										<div className="errordiscount"></div>
									</div>									
									</>
									}
									{(this.state.selectedUserType == 'rider' || this.state.selectedUserType == 'driver') &&
									<>									
									<div className="form-group">
										<label> Tow Booking Discount (%)<span class="required" style={{ color: "red" }} >* </span></label>
										<input type="text"  name="towDiscount" onChange={this.handleInputChange} className="form-control" value={this.state.towDiscount} />			
										<div className="errortowDiscount"></div>
									</div>
									</>
									}
									{this.state.selectedUserType == 'company' &&
									<div className="form-group">
										<label> Set Driver Limit<span class="required" style={{ color: "red" }} >* </span></label>
										<input type="text"  name="driverCount" onChange={this.handleInputChange} className="form-control" value={this.state.driverCount} />			
										<div className="errordriverCount"></div>
									</div>
									}
									{this.state.selectedUserType == 'driver' &&
									<div className="form-group">
										<label> Set Company Limit<span class="required" style={{ color: "red" }} >* </span></label>
										<input type="text"  name="companyCount" onChange={this.handleInputChange} className="form-control" value={this.state.companyCount} />			
										<div className="errorcompanyCount"></div>
									</div>
									}
									<div className="form-group">
										<label>Image (jpeg,jpg,png,svg)</label>
										<div className="choose-file">
											{this.state.isHidden && <div className="image_success"></div>}
											<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
										</div>
										{preview}											
										<div className="errorimage"></div>  
									</div> 
									<div className="form-group">
										<label>Plan Info</label>
										<CKEditor
											data={this.state.planInfo || ''}
											type="classic"
											onChange={(evt) => {
												this.onEditorChange('planInfo', evt);
											}}
										/>
										<div className="errorplanInfo"></div>
									</div>
								
								</div>
								
								<div className="form-right">
									<div className="form-group">
										<label>Membership Name<span class="required" style={{ color: "red" }} >* </span></label>
										<input type="text" name="m_title" onChange={this.handleInputChange} className="form-control" value={this.state.m_title}/>
										<div className="errortitle"></div>
									</div>
									<div className="form-group">					
										<label>Period<span class="required" style={{ color: "red" }} >* </span></label>
										<Select 
											value={selectedPeriodOption?selectedPeriodOption:""}
											options={lang.common.period_option} 
											onChange={this.handleChange.bind(this, 'period')}
										/>
										<div className="errorperiod"></div>
									</div> 
									<div className="form-group">
										<label>Description</label>
										<CKEditor
											data={this.state.description || ''}
											type="classic"
											onChange={(evt) => {
												this.onEditorChange('description', evt);
											}}
										/>
										<div className="errordescription"></div>
									</div>
									<div className="form-group">					
										<label>Status<span class="required" style={{ color: "red" }} >*</span></label>
										<Select 
											name="status"
											value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
											options={lang.common.status_option} 
											isSearchable = {false}
											onChange={this.handleChange.bind(this, 'status')}
										/>
									</div> 
								</div>	
							</div>		
							<div className="btn-group export">	
								<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" >
									{/* <span className="load-	data"></span>  */}
									Submit
								</button>
							</div>
						</form>
					</div>	
				</div>	
			</div>
		 	
		</div>
	);
}
}


export default (withRouter(Add));